import React from 'react';
import './App.css';
import Dashboard from "./pages/Dashboard";

function App() {
  return (
    <div className="App">
    <Dashboard></Dashboard>
    </div>
  );
}

export default App;
